import {Layout,} from "antd";
import React, {useMemo, useState} from "react";
import {Contain} from "@components/layout";
import {Helmet as Head} from "react-helmet-async";
import HomePageSearchBox from "@mwPages/homepage/HomePageSearchBox";
import HomePageCarousel from "@mwPages/homepage/HomePageCarousel";
import {useGetPageBySlugQuery} from "@services/Page";
import {transformHomePageContent} from "@lib/transformWordPressContent";
import useIsLoggedIn from "@hooks/useIsLoggedIn";
import HomePageMyComics from "@mwPages/homepage/HomePageMyComics";
import {useWindowSize} from "@components/window-size-provider";
import HomePageLists from "@mwPages/homepage/HomePageLists";
import useSubscriptionType from "@hooks/useSubscriptionType";
import HomePageCPContent from "@mwPages/homepage/HomePageCPContent";
import HomePageTopTen from "@mwPages/homepage/HomePageTopTen";
import HomePageNewReleases from "@mwPages/homepage/HomePageNewReleases";
import HomePageMarketplace from "@mwPages/homepage/HomePageMarketplace";
import HomePageNewMemberModal from "@mwPages/homepage/HomePageNewMemberModal";

const HomePage = () => {

    const [sectionLoaded, setSectionLoaded2] = useState({
        homepage: false,
        mycomics: false,
        topten: false,
        newreleases: false,
        marketplace: false,
    });
    const setSectionLoaded = (section: string) => setSectionLoaded2({...sectionLoaded, [section]: true});

    const windowDimensions = useWindowSize();
    const pageQuery = useGetPageBySlugQuery({slug: 'home-page-content'});
    const isLoggedIn = useIsLoggedIn();
    const subscriptionType = useSubscriptionType();
    const allowPremium = useMemo(() => (subscriptionType.isTrial || subscriptionType.isUnlimited), [subscriptionType]);

    const pageContent = useMemo(() => {
        if(pageQuery.data) {
            setSectionLoaded('homepage');
            return transformHomePageContent(pageQuery.data, isLoggedIn);
        }
        return null;
    }, [pageQuery, isLoggedIn]);

    const showDesktopView = useMemo(() => {
        return windowDimensions.over(799);
    }, [windowDimensions]);

    return (
    <Layout className="page homepage">
      <Head>
        <title>CovrPrice - The ultimate tool for comic collectors and speculators.</title>
      </Head>

      <HomePageCarousel slides={pageContent && pageContent.slides} />
      <HomePageSearchBox showDesktopView={showDesktopView} />

        {sectionLoaded.homepage && (
            <>
                <Contain>
                    {isLoggedIn && (
                        <HomePageMyComics windowDimensions={windowDimensions} showDesktopView={showDesktopView} onLoad={() => setSectionLoaded('mycomics')} />
                    )}

                    <HomePageLists listItems={pageContent && pageContent.listItems} allowPremium={allowPremium} windowDimensions={windowDimensions} />

                </Contain>
                    <HomePageTopTen windowDimensions={windowDimensions} targetDate={pageContent?.weeklyTopTenDate} onLoad={() => setSectionLoaded('topten')}/>
                <Contain>
                    <HomePageCPContent windowDimensions={windowDimensions} cpContent={pageContent?.cpContent} />

                    {sectionLoaded.topten && (
                        <HomePageNewReleases windowDimensions={windowDimensions} onLoad={() => setSectionLoaded('newreleases')}/>
                    )}
                </Contain>

                {sectionLoaded.newreleases && (
                    <HomePageMarketplace windowDimensions={windowDimensions} onLoad={() => setSectionLoaded('marketplace')}/>
                )}
            </>
        )}

        <Contain>
        <HomePageNewMemberModal windowDimensions={windowDimensions} showDesktopView={showDesktopView} bgUrl={pageContent?.images.modal_bg_url} />
        </Contain>
    </Layout>
  );
};

export default HomePage;
